
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe13 as ObiHydraulicPipe13Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-13.js';
 
 
 

 
 export const ObiHydraulicPipe13 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-13',
   elementClass: ObiHydraulicPipe13Element,
   events: {
     
   }
  });
 
 